import workbench from "./modules/workbench";
import clue from "./modules/clue";
import site from "./modules/site";
import seo from "./modules/seo";
import google from "./modules/google";
import perm from "./modules/perm";
import setting from "./modules/setting";

export default [
  ...workbench,
  ...clue,
  ...site,
  ...seo,
  ...google,
  ...perm,
  ...setting,
];
